import { TextCardColumnCms } from '@cerifi/ui/cms/layouts/text-card-column.cms'

import { ComponentTextCardColumn } from '../../../__generated/graphql.types'

const TextCardColumn = ({ content }: { content: ComponentTextCardColumn }) => {
  return (
    <TextCardColumnCms
      id={content.sys.id}
      title={content.title}
      description={content.description}
      columnOneTitle={content.columnOneTitle as string}
      columnTwoTitle={content.columnTwoTitle as string}
      columnOneCardsCollection={
        (content.columnOneCardsCollection?.items as any) || []
      }
      columnTwoCardsCollection={
        (content.columnTwoCardsCollection?.items as any) || []
      }
    />
  )
}

export default TextCardColumn
